var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 65,
    viewBox: "0 0 40 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3023 15.3821H38.4552C39.3024 15.3821 39.9934 14.6911 39.9934 13.8439V1.53821C39.9934 0.690962 39.3024 0 38.4552 0H29.2259C19.8975 0 12.3057 7.5919 12.3057 16.9203V24.7344H1.53821C0.690962 24.7344 0 25.4254 0 26.2726V38.4552C0 39.3024 0.690993 39.9934 1.53821 39.9934H11.2358V63.0665C11.2358 63.9137 11.9268 64.6047 12.774 64.6047H25.6173C26.4645 64.6047 27.1555 63.9137 27.1555 63.0665V39.9934H35.2465C35.9465 39.9934 36.5623 39.5247 36.7396 38.8397L39.9482 26.5341C40.0714 26.0714 39.9723 25.5817 39.6778 25.2031C39.3864 24.8276 38.9388 24.6023 38.4641 24.6023H27.6967V19.9876C27.6967 17.443 29.7666 15.373 32.3113 15.373L32.3023 15.3821ZM26.1495 27.6877H36.4632L34.0567 36.917H25.612C24.7647 36.917 24.0738 37.608 24.0738 38.4552V61.5283H14.3069V38.4552C14.3069 37.6079 13.6159 36.917 12.7687 36.917H3.07111V27.8108H13.8386C14.6858 27.8108 15.3768 27.1198 15.3768 26.2726V16.9203C15.3768 9.28931 21.5837 3.07641 29.2206 3.07641H36.9117V12.3057H32.297C28.058 12.3057 24.606 15.7576 24.606 19.9967V26.1495C24.606 26.9968 25.297 27.6877 26.1442 27.6877H26.1495Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6148696dd268eaed2553acf811e21537.svg";
export { ForwardRef as ReactComponent };